<template>
  <div class="app-container">
    <ul class="list">
      <li
        v-for="(item, index) in goodsArr"
        :key="index"
        class="flexbox item"
        :class="{ no_good: item.stockNum === 0 }"
        @click="goodDetail(item)"
      >
        <div class="good_img">
          <img :src="item.shareImg" alt="" />
        </div>
        <div class="flexbox good_info">
          <div class="name">{{ item.goodsName }}</div>
          <div class="stock">剩余库存{{ item.stockNum }}件</div>
          <div class="price">¥{{ item.salePrice }}</div>
        </div>
        <div class="check_box" @click.stop="checked(item)">
          <img src="../../../images/icon/auth_radio_checked.png" alt="" v-if="item.checked" />
          <img alt="" src="../../../images/icon/auth_radio.png" v-else />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('goods/physical', [
      'goodsArr',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('args', ['goodsIds', 'shareCode']),
    // 商品是否联合限购
    hasLimit() {
      const { hasLimit } = this.limitData || {}
      return hasLimit
    }
  },
  created() {},

  methods: {
    ...mapMutations({
      checkedGood: 'goods/physical/checkedGood'
    }),
    checked(data) {
      this.checkedGood(data.goodsId)
    },
    goodDetail(data) {
      this.$router.push({
        path: `/goods-physical-detail`,
        // path: `/goods`,
        query: { goodsId: data.goodsId, isChecked: data.checked }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.list {
  padding-top: 0.4rem;
  .item {
    box-sizing: border-box;
    padding: 0 0.48rem 0.48rem;
    align-items: flex-start;
    height: 2.32rem;
    .good_img {
      width: 1.72rem;
      height: 100%;
      flex-shrink: 0;
      img {
        border-radius: 0.04rem;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .good_info {
      flex: auto;
      height: 100%;
      color: #000;
      padding: 0.08rem 0 0.14rem 0.2rem;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .name {
        font-size: 0.32rem;
        line-height: 0.44rem;
        font-weight: 500;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .stock {
        font-size: 0.24rem;
        color: #999;
      }
      .price {
        font-size: 0.28rem;
        color: #00b25a;
      }
    }
    .check_box {
      flex-shrink: 0;
      width: 1rem;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        display: block;
        width: 0.34rem;
        height: 0.34rem;
      }
    }
  }
}
.no_good {
  .name,
  .stock,
  .price {
    color: #999999 !important;
  }
  .check_box {
    display: none;
  }
  .good_img {
    position: relative;
    &::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      content: '';
      background: rgba(0, 0, 0, 0.4) url('../../../images/icon/no_good.png') no-repeat center center;
      background-size: 80%;
    }
  }
}
</style>
